import { Phone, Mail, Facebook, Star, MapPin, Clock } from "lucide-react";
import { BUSINESS, CITIES } from "../data/business";
import { CLEANING_PAGE_LINKS } from "../data/cleaningPages";
import { HVAC_PROMO_HREF } from "../seo/hosts";
export default function Footer() {
  return (
    <footer className="bg-[#0B1A3F] text-slate-200" id="contact" data-testid="site-footer">
      <div className="container-ss py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-3">
          <div className="flex items-center gap-3 mb-2">
            <img
              src={BUSINESS.logoSrc}
              alt="S.S. Cleaning Solutions logo"
              width="56"
              height="56"
              loading="lazy"
              className="h-14 w-14 object-contain bg-white rounded-xl p-1"
            />
            <div>
              <h3 className="font-display text-2xl font-bold text-white leading-tight">S.S. Cleaning Solutions</h3>
              <p className="text-xs uppercase tracking-[0.18em] text-emerald-300 font-semibold">
                Residential & Commercial Cleaning
              </p>
            </div>
          </div>
          <p className="mt-3 text-slate-300 leading-relaxed">
            A locally family-owned and woman-owned cleaning company serving Northwest Indiana.
            Detail-oriented cleaning without cutting corners.
          </p>
          <p className="mt-3 text-sm text-white/80 font-medium">
            Reliable • Detailed • Trustworthy
          </p>
          <div className="mt-5 flex flex-wrap gap-3">
            <a
              href={BUSINESS.googleBusiness}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white text-[#0B1A3F] font-semibold text-sm hover:bg-slate-100"
              data-testid="footer-google-business-btn"
            >
              <Star size={16} className="fill-yellow-400 text-yellow-400" /> Read Our Google Reviews
            </a>
            <a
              href={BUSINESS.facebook}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 text-white font-semibold text-sm hover:bg-white/20"
              data-testid="footer-facebook-btn"
            >
              <Facebook size={16} /> Follow Us on Facebook
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-white font-semibold mb-3">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2">
              <Phone size={16} className="text-emerald-300" />
              <a href={BUSINESS.phoneHref} className="hover:text-white" data-testid="footer-phone-link">
                {BUSINESS.phone}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={16} className="text-emerald-300" />
              <a href={BUSINESS.emailHref} className="hover:text-white break-all" data-testid="footer-email-link">
                {BUSINESS.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={16} className="text-emerald-300 mt-0.5" />
              <span>Serving Northwest Indiana</span>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-white font-semibold mb-3">Business Hours</h4>
          <ul className="space-y-2 text-sm">
            {BUSINESS.hours.map((h) => (
              <li key={h.day} className="flex items-start gap-2">
                <Clock size={16} className="text-emerald-300 mt-0.5" />
                <div>
                  <div className="text-white font-medium">{h.day}</div>
                  <div className="text-slate-300">{h.value}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-white font-semibold mb-3">Explore</h4>
          <ul className="text-sm space-y-2 text-slate-300">
            {CLEANING_PAGE_LINKS.map((l) => (
              <li key={l.path}>
                <a href={l.path} className="hover:text-white" data-testid={`footer-page-${l.path.slice(1)}`}>{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-white font-semibold mb-3">Service Areas</h4>
          <ul className="text-sm space-y-2 text-slate-300">
            {CITIES.slice(0, 6).map((c) => (
              <li key={c.slug}>
                <a href={`/areas/${c.slug}`} className="hover:text-white" data-testid={`footer-city-${c.slug}`}>
                  {c.name.replace(", IN", "")}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-ss py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} S.S. Cleaning Solutions. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="/legacy" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-legacy-link">
              Our Legacy
            </a>
            <a
              href={HVAC_PROMO_HREF}
              className="text-slate-400 hover:text-white transition-colors"
              data-testid="footer-hvac-link"
            >
              HVAC Services
            </a>
            <p>Family & woman-owned • Northwest Indiana</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
